module.exports = __webpack_public_path__ + "img/whats-new-4_en.07c8951.jpg";